import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-audit-pending',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {
  @Input() count: number = 0;
}
